import axios from '@/api/axios';
import type {
  WebhookDeliveryDetail,
  WebhookDeliveryListResponse,
  WebhookDeliveryStatus,
} from '@/types/WebhookDelivery';

export const webhookDeliveriesService = {
  getBusinessWebhookDeliveries: async (
    businessId: string,
    query: {
      limit: number;
      cursor?: string;
      event?: string;
      status?: WebhookDeliveryStatus;
    },
  ): Promise<WebhookDeliveryListResponse> => {
    const searchParams = new URLSearchParams();
    searchParams.append('limit', String(query.limit));
    if (query.cursor) {
      searchParams.append('cursor', query.cursor);
    }
    if (query.event) {
      searchParams.append('event', query.event);
    }
    if (query.status) {
      searchParams.append('status', query.status);
    }

    const response = await axios.get<WebhookDeliveryListResponse>(
      `/v2/admin/business/${businessId}/webhook-deliveries?${searchParams}`,
    );
    return response.data;
  },

  getBusinessWebhookDeliveryDetail: async (
    businessId: string,
    webhookId: string,
  ): Promise<WebhookDeliveryDetail> => {
    const response = await axios.get<{data: WebhookDeliveryDetail}>(
      `/v2/admin/business/${businessId}/webhook-deliveries/${encodeURIComponent(
        webhookId,
      )}`,
    );
    return response.data?.data;
  },
};
